import React from 'react';
const comparisonRows = [{
  situation: 'Las tardes',
  without: 'Celu en mano, berrinche al sacárselo',
  with: 'Actividades listas, nene enfocado'
}, {
  situation: 'Tu tiempo',
  without: 'Buscando ideas en Pinterest a las 23hs',
  with: 'Todo impreso y listo en minutos'
}, {
  situation: 'El aprendizaje',
  without: 'Videos pasivos sin estimulación real',
  with: 'Letras, números e inglés jugando'
}, {
  situation: 'Los berrinches',
  without: 'Cada vez que se le saca el celu',
  with: 'Rutinas claras que el nene acepta'
}, {
  situation: 'La conexión',
  without: 'Cada uno en su pantalla',
  with: 'Momentos reales madre e hijo'
}, {
  situation: 'El progreso',
  without: 'Sin saber si avanza o no',
  with: 'Actividades por nivel que crecen con él'
}, {
  situation: 'Los viajes',
  without: 'Celu obligatorio para que se calme',
  with: 'Fichas portables para llevar a todos lados'
}, {
  situation: 'Tu culpa',
  without: 'Sintiéndote mal por darle la pantalla',
  with: 'Tranquila porque le dás lo mejor'
}];
const blocks = [{
  emoji: '📅',
  title: 'Bloque 1 — Plan Semanal Anti-Berrinche',
  desc: 'Rutina de 7 días lista para aplicar. Cuándo, cuánto y cómo reemplazar la pantalla sin conflictos.',
  span: false
}, {
  emoji: '🧠',
  title: 'Bloque 2 — Guía del Primer Paso',
  desc: 'Cómo presentarle las fichas a tu hijo por primera vez para que las elija solo por encima del celular.',
  span: false
}, {
  emoji: '😤',
  title: 'Bloque 3 — Protocolo Anti-Berrinche',
  desc: 'Qué hacer cuando llora por el celu. 5 pasos concretos para redirigir su atención sin gritos ni culpa.',
  span: false
}, {
  emoji: '🏆',
  title: 'Bloque 4 — Sistema de Logros',
  desc: 'Stickers y diplomas imprimibles para celebrar cada avance. El nene querrá hacer más actividades para ganar premios.',
  span: false
}, {
  emoji: '📦',
  title: 'Recursos incluidos:',
  desc: 'Plan Semanal · Tabla de Rutinas · Protocolo Anti-Berrinche · Diplomas Imprimibles · Stickers de Logros · Guía de Progreso · Checklist de Avance',
  span: true
}];
export function ProBusiness() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(255, 247, 237)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-242">
      <div className="mx-auto max-w-4xl" data-id="element-243">

        {/* TÍTULO */}
        <div className="mb-8 text-center" data-id="element-244">
          <h2 className="font-black text-gray-900 m-0 mb-3 text-[26px]" data-id="element-245">
            🏆 ¿QUÉ AGREGA EL{' '}
            <span className="text-orange-500" data-id="element-246">MÉTODO DESCONECTADO™</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-base text-gray-600 m-0" data-id="element-247">
            El sistema paso a paso para eliminar la dependencia a la pantalla en
            7 días, sin berrinches y sin culpa.
          </p>
        </div>

        {/* HINT MOBILE */}
        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-248">
          <span data-id="element-249">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* TABLA COMPARATIVA */}
        <div className="mb-10 overflow-x-auto bg-white border border-orange-200 rounded-xl shadow-sm touch-pan-x" style={{
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-250">
          <div className="min-w-[600px]" data-id="element-251">

            {/* HEADER */}
            <div className="grid grid-cols-3" style={{
            backgroundColor: 'rgb(248, 250, 252)'
          }} data-id="element-252">
              <div className="p-3 text-sm font-bold text-gray-900" data-id="element-253">
                Situación
              </div>
              <div className="p-3 text-center text-sm font-bold text-gray-500 border-l border-orange-200" data-id="element-254">
                Sin Método Desconectado™
              </div>
              <div className="p-3 text-center text-sm font-bold text-orange-500 border-l border-orange-200" data-id="element-255">
                Con Método Desconectado™
              </div>
            </div>

            {/* FILAS */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-256">
                <div className="p-3 text-xs sm:text-sm text-gray-900 font-medium" data-id="element-257">
                  {row.situation}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-500 border-l border-gray-200 bg-gray-50" data-id="element-258">
                  ✗ {row.without}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-900 border-l border-gray-200 bg-orange-50" data-id="element-259">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* BLOQUES */}
        <h3 className="text-xl font-black text-center text-gray-900 m-0 mb-6" data-id="element-260">
          ✅ MÉTODO DESCONECTADO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-261">
          {blocks.map(block => <div key={block.title} className={`bg-white border border-orange-200 rounded-lg p-4 shadow-sm ${block.span ? 'md:col-span-2' : ''}`} data-id="element-262">
              <h4 className="text-base font-bold text-orange-500 m-0 mb-1" data-id="element-263">
                {block.emoji} {block.title}
              </h4>
              <p className="text-xs text-gray-600 m-0" data-id="element-264">{block.desc}</p>
            </div>)}
        </div>

      </div>
    </section>;
}